import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { accessLocalStorage, readIpRoutes } from '../../../services';
import './RoutesList.css';

function RoutesList() {
  const history = useHistory();
  const [routes, setDataRoutes] = useState([]);

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getDataRoutes = await readIpRoutes();
    
    const filterRoutes = getDataRoutes[0].filter((element) => !element.includes('kernel'));
    
    setDataRoutes(getDataRoutes[0]);
  }, []);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="routes-list-container">
      <div className="routes-header">
        <div className="routes-title-wrapper">
          <svg className="routes-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
          </svg>
          <div>
            <h1 className="routes-title">Rotas de Rede</h1>
            <p className="routes-subtitle">Visualize as rotas configuradas no sistema</p>
          </div>
        </div>
      </div>

      <div className="routes-table-wrapper">
        <table className="routes-table">
          <thead className="routes-table-header">
            <tr>
              <th>Rotas</th>
            </tr>
          </thead>
          <tbody>
            {
              routes.map((route, index) => (
                <tr key={ index }>
                  <td>{ route }</td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RoutesList;
